import { usePassportProvider } from "@/context";
import { useGetWalletGems } from "@/hooks/api";
import { useMemo } from "react";
import { HeaderProgressBar } from "../HeaderProgressBar";
import { useWeeklyRewards } from "../WeeklyRewardsProvider";
import { HeaderOnboardingBar } from "./HeaderOnboardingBar";

export const ProgressBar = () => {
  const { isLoggedIn, walletAddress } = usePassportProvider();
  const { isTicketsLoading, hasEverEnteredSweepstake, entryFee } =
    useWeeklyRewards();
  const { walletGems } = useGetWalletGems(walletAddress || null, false);

  const shouldShowOnboardingProgressBar = useMemo(
    () =>
      isLoggedIn &&
      !isTicketsLoading &&
      (walletGems?.gems ?? 0) < entryFee &&
      !hasEverEnteredSweepstake,
    [
      isLoggedIn,
      isTicketsLoading,
      walletGems?.gems,
      hasEverEnteredSweepstake,
      entryFee,
    ],
  );
  const shouldShowHeaderProgressBar = useMemo(
    () => isLoggedIn && !isTicketsLoading && !shouldShowOnboardingProgressBar,
    [isLoggedIn, isTicketsLoading, shouldShowOnboardingProgressBar],
  );

  return (
    <>
      {shouldShowHeaderProgressBar && <HeaderProgressBar />}
      {shouldShowOnboardingProgressBar && <HeaderOnboardingBar />}
    </>
  );
};
